import React from "react";
import PVModuleOption from "./pvModuleOption";
import StructureOption from "./structureOption";
import ShedOption from "./shedOption";
import { useDispatch, useSelector } from "react-redux";
import { handleInputChange, handleStructure } from "../DSFunction";
import CapacityOption from "./capacityOption";

export default function SmithStructure({ emptyValues }) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];

  const handleKeyPress = (e) => {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      handleStructure({
        dispatch,
        roofInfo,
        gridInfo,
        quantityInfo,
        roofDetail,
        designParameter,
      });
    }
  };
  

  return (
    <React.Fragment>
      <PVModuleOption
        emptyValues={emptyValues}
        handleKeyPress={handleKeyPress}
      ></PVModuleOption>

      <StructureOption></StructureOption>
      {roofDetail.structureType === "Single" &&
        roofDetail.mountingStructure !== "Select" && (
          <>
            <CapacityOption handleKeyPress={handleKeyPress}></CapacityOption>
            {roofDetail.roofType === "Shed Roof" && (
              <ShedOption handleKeyPress={handleKeyPress}></ShedOption>
            )}
          </>
        )}
      {roofDetail.structureType === "Multiple" &&
        roofDetail.mountingStructure !== "Select" && (
          <div className="formWithLabel shedForm">
            <label>No of Row</label>
            <input
              type="text"
              value={roofDetail.multiStructureRow}
              name="multiStructureRow"
              onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
              onKeyPress={(e) => handleKeyPress(e)}
            ></input>
          </div>
        )}
    </React.Fragment>
  );
}
